import cn from 'classnames'
import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'
import { CharacterSkeleton } from './CharacterSkeleton'

export function StoryCharacterSkeleton({ className }: FunctionComponentType) {
  return (
    <section
      className={cn('card p-[30px] mobile:p-0 dark:border-purple', className)}
    >
      <div className='flex space-x-[20px] py-[20px] overflow-x-auto'>
        {Array.from({ length: 4 }).map((_, i) => (
          <CharacterSkeleton key={i} />
        ))}
      </div>
    </section>
  )
}
